import { useTranslation } from 'react-i18next';
import React, { } from 'react';
import NotInformation from './NotInformation';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description component CustomGalleryFiles.
 * @param String id: Button identifier (required) (required).
 * @param List<Object> listData: A list of image objects that contains at least the image id and the image itself: {id, image} (required).
 * @param event click: click event (optional).
 * @param String className: Style for the image container (optional).
 * @returns {JSX.Element}
 */
const CustomGalleryFiles = ({ id = "fu_cfp_file", listData, click, className = '' }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={`gallery-files-container ${className}`}>
                {listData?.content?.length > 0 ? (
                    listData?.content?.map((item, index) => {
                        return (
                            <div className='vehicle_image'>
                                {click &&
                                    <button
                                        className='cross_icon'
                                        id={`${id}_${index}`}
                                        onClick={() => {
                                            if (click)
                                                click(item)
                                        }}
                                    >
                                        <i className='fa fa-times' aria-hidden='true'></i>
                                    </button>
                                }
                                <img
                                    src={item?.image ? `data:image/png;base64,${item?.image}` : ''}
                                    alt=''
                                />
                            </div>
                        );
                    })
                ) : (
                    <>
                        <NotInformation text={t('no_information')} card={true} />
                    </>
                )}
            </div>
        </>


    )
}

export default CustomGalleryFiles
